/*--------------------------------------------------------------
>>> TABLE OF CONTENTS:
----------------------------------------------------------------
1.0 - ADA Walker
2.0 - Mobile Menu
3.0 - Drilldown
--------------------------------------------------------------*/

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const siteHeader = document.querySelector('.site-header');

// 1.0 - ADA Walker
export function menuWalker() {
    //ADA Compliance roles
    jQuery(".menu-primary .sub-menu").attr("role","menubar");
    jQuery(".menu-primary li").attr("role","menuitem");
    jQuery(".menu-utility li").attr("role","menuitem");
	
    jQuery( function ( $ ) {
        // Focus styles for menus when using keyboard navigation
        // Properly update the ARIA states on focus (keyboard) and mouse over events
        $( '[role="menubar"]' ).on( 'focus.aria  mouseenter.aria', '[aria-haspopup="true"]', function ( ev ) {
            $( ev.currentTarget ).attr( 'aria-expanded', true );
        } );
		
        // Properly update the ARIA states on blur (keyboard) and mouse out events
        $( '[role="menubar"]' ).on( 'blur.aria  mouseleave.aria', '[aria-haspopup="true"]', function ( ev ) {
            $( ev.currentTarget ).attr( 'aria-expanded', false );
        } );
    } );
}

// 2.0 - Mobile Menu
export function mobileMenu() {
    const burger = document.querySelector('.js-menu-toggle');
    const closeMenu = document.querySelector('.js-menu-close');
    
    if (burger) {
        // eslint-disable-next-line
        document.addEventListener('click', function(event) {
            // Toggle menu when clicking on the burger
            if (event.target.closest('.js-menu-toggle')) {
                siteHeader.classList.toggle('menu-open');
            } 
            // Close menu when clicking outside of the menu item
            // else if (siteHeader.classList.contains('menu-open') && !event.target.closest('.site-header__primary-menu')) {
            //     siteHeader.classList.remove('menu-open');
            // }

            // Lock body
            if (siteHeader.classList.contains('menu-open')) {
                document.body.classList.add('body-lock');
                // scroll to the top of the page
                //window.scrollTo(0, 0);
            } else {
                document.body.classList.remove('body-lock');
            }
        });
    }

    if (closeMenu) {
        closeMenu.addEventListener('click', function(event) {
            event.stopPropagation();
            siteHeader.classList.remove('menu-open');
            document.body.classList.remove('body-lock');
        });
    }

    // eslint-disable-next-line
    // window.addEventListener('resize', function() {
    //     if (window.innerWidth < 1024) {
    //         siteHeader.classList.remove('menu-open');
    //         document.body.classList.remove('body-lock');
    //     }
    // });    
}

export function menuResize() {
    siteHeader.classList.remove('menu-open');
    document.body.classList.remove('body-lock');
}


// 3.0 - Drilldown
export function menuDrilldown() {
    const menuHasChildren = document.querySelectorAll('.menu-item-has-children > a');
    const menuGroup = document.querySelector('.site-header__menu');
    const subMenu = siteHeader.querySelectorAll('.sub-menu');
    
    if (subMenu) {
        subMenu.forEach(function(menu) {
            const createdDiv = document.createElement('button');
            createdDiv.classList.add('menu-item-back');
            createdDiv.innerHTML = '<i class="fa-solid fa-angle-left icon-back"></i> Back';
            menu.prepend(createdDiv);
    
            createdDiv.addEventListener('click', function(event) {
                event.stopImmediatePropagation();
                event.preventDefault();
                setActive(menu);
            });
        });

        menuHasChildren.forEach(function(menu) {
            menu.addEventListener('click', function(event) {
                if (matchMedia('(max-width: 1133px)').matches) {
                    const parentItem = menu.closest('.menu-item');
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    setActive(parentItem);
                }
            });
        });
    
        const setActive = (el) => {
            const parentLi = el.closest('li'); // Find the closest parent li element
            const menuWrapper = document.querySelector('.site-header__menu-primary');
            const isActive = parentLi.classList.contains('is-active');
    
            // If the element is active, deactivate all siblings
            if (isActive) {
                if (menuWrapper) {
                    menuWrapper.style.minHeight = '';
                }
                
                parentLi.classList.remove('is-active');
                menuGroup.classList.remove('is-active');
            } else {
                // Find the maximum height of all .sub-menu elements inside .menu-primary
                let maxHeight = 0;
                subMenu.forEach(function(menu) {
                    const menuHeight = menu.offsetHeight;
                    if (menuHeight > maxHeight) {
                        maxHeight = menuHeight;
                    }
                });

                // Set the maximum height as the min-height of .site-header__menu-primary
                if (menuWrapper) {
                    menuWrapper.style.minHeight = `${maxHeight}px`;
                }

                parentLi.classList.add('is-active');
                menuGroup.classList.add('is-active');
            }
        };
    }

    // eslint-disable-next-line
    window.addEventListener('resize', function() {
        if (window.innerWidth < 1024) {
            // remove the maximum height as the min-height of .site-header__menu-primary
            const menuWrapper = document.querySelector('.site-header__menu-primary');
            const menu = document.querySelector('.site-header__menu');

            if (menuWrapper) {
                menuWrapper.style.minHeight = '';
            }

            // remove all .is-active from .menu-item-has-children
            document.querySelectorAll('.menu-item-has-children').forEach(function(item) {
                item.classList.remove('is-active');
                menu.classList.remove('is-active');
            });
        }
    });
}


export function scrollingNav() {
    const main = document.querySelector('.scrolling-navigation');

    if (main) {
        const links = document.querySelectorAll('.scrolling-navigation__main .link');
        const sections = document.querySelectorAll('#content [id]'); // Select all elements with an ID

        sections.forEach(section => {
            ScrollTrigger.create({
                trigger: section,
                start: "top center", // Adjust as needed
                end: "bottom center", // Adjust as needed
                onEnter: () => setActiveLink(section.id),
                onEnterBack: () => setActiveLink(section.id),
                // markers: true // Remove this line if you don't want markers
            });
        });

        // Set active state on click
        links.forEach(link => {
            link.addEventListener('click', function() {
                setActiveLink(link.querySelector('a').getAttribute('href').substring(1)); // Pass the ID without the '#'
                main.classList.remove('active');
            });
        });

        // eslint-disable-next-line
        function setActiveLink(id) {
            links.forEach(link => {
                const linkId = link.querySelector('a');
                if (linkId.getAttribute('href').includes(id)) {
                    links.forEach(sibling => sibling.classList.remove('active'));
                    link.classList.add('active');
                    link.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); // Scroll into view
                }
            });
        }
    }

    if (main) {
        gsap.to(main, {
            scrollTrigger: {
                trigger: main,
                start: "top top", // Trigger when 'main' hits the top of the screen
                end: "999999px", // A very large value to simulate no end
                onEnter: () => main.classList.add('is-stuck'),
                onLeaveBack: () => main.classList.remove('is-stuck'),
                scrub: false,
                // markers: true // Remove this line if you don't want markers
            }
        }); 
    } 
}